import { Users, Gift, Calendar } from 'lucide-react'

export default function Promotions() {
    return (
        <div className="lg:block md:p-4 pt-4 md:pt-0 space-y-4 h-full">
            <div className="bg-gradient-to-r from-cyan-500 to-blue-500 rounded-lg p-4 text-white">
                <div className="flex items-center space-x-2">
                    <Users className="h-6 w-6" />
                    <h3 className="font-bold">Invite Friends</h3>
                </div>
                <p className="mt-2">Get Cashback!</p>
            </div>

            <div className="bg-gradient-to-r from-pink to-purple-500 rounded-lg p-4 text-white">
                <div className="flex items-center space-x-2">
                    <Gift className="h-6 w-6" />
                    <h3 className="font-bold">Welcome Bonus</h3>
                </div>
                <p className="mt-2">1st Deposit +100%</p>
            </div>

            <div className="bg-gradient-to-r from-green to-teal-500 rounded-lg p-4 text-white">
                <div className="flex items-center space-x-2">
                    <Calendar className="h-6 w-6" />
                    <h3 className="font-bold">Daily Check-in Bonus</h3>
                </div>
                <p className="mt-2">Login to get free cash everyday</p>
            </div>
        </div>
    )
}

